import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      const result = await loginWithGoogleSession(sessionId);
      if (result.success) {
        navigate('/dashboard', { replace: true, state: { user: result.data } });
      } else {
        navigate('/login', { replace: true });
      }
    })();
  }, [location, loginWithGoogleSession, navigate]);

  return (
    <main className="page-content">
      <div className="flex items-center justify-center" style={{ minHeight: 'calc(100vh - 72px)' }}>
        <Loader2 size={32} className="animate-spin" style={{ color: 'var(--teal)' }} />
      </div>
    </main>
  );
};

export default AuthCallback;
